module.exports = __webpack_public_path__ + "img/sin_foto.3fa8590b.gif";